import React from 'react';

export default function Hero() {
  return (
    
    <section
      className="h-screen flex items-center justify-center bg-cover bg-center px-4"
      style={{ backgroundImage: "url('https://images.unsplash.com/photo-1498050108023-c5249f4df085?auto=format&fit=crop&w=1600&q=80')" }}
    >
      <div className="bg-white bg-opacity-80 p-8 rounded-lg max-w-2xl text-center shadow-lg">
        <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">Impulsamos la innovación tecnológica</h2>
        <p className="text-lg text-gray-700 mb-6">En Zamintech nos dedicamos al desarrollo de software, apps móviles y la venta de equipos tecnológicos.</p>
        <a href="#contacto">
          <button className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-full text-lg transition-all">
            Contáctanos
          </button>
        </a>
      </div>
    </section>
  );
}
